module.exports = __webpack_public_path__ + "img/logo dark theme.7db4264f.png";